// @ts-strict-ignore
import {Component, Input, output} from "@angular/core";
import {
	ClientApplicationTile,
	DeviceViewService,
	IPermissionOverrule,
	LayoutVariants,
	SimConfigurationService,
	SimUserExtendedService,
} from "@services";
import {Translations} from "@translations";
import {environment} from "../../../../environments/environment";

@Component({
	selector: "app-tile",
	templateUrl: "./app-tile.component.html",
	styleUrls: ["./app-tile.component.scss"],
	standalone: false,
})
export class AppTileComponent {
	T = Translations;
	LayoutVariants = LayoutVariants;

	hasLicenseModule = SimConfigurationService.hasLicenseModule;

	baseHref = environment.baseHref;

	@Input() tile: ClientApplicationTile;
	@Input() disabled: boolean;
	@Input() configMode: boolean = false;
	@Input() activeTrainingSessionId: string = null;
	@Input() size: "big" | "medium" | "small";

	public icon_path = this.baseHref + "/assets/icons/appIcons/";
	moveDashboardTileClicked = output<void>();
	moveDashboardTileUpClicked = output<void>();
	moveDashboardTileDownClicked = output<void>();
	removeDashboardTile = output<void>();
	@Input() tileIndex: number = -1;
	@Input() tileAmount: number;
	@Input() currentTileInEditModeIndex: number;

	@Input() permissionOverrule: IPermissionOverrule = null;

	constructor(
		public _deviceView: DeviceViewService,
		public _simUserService: SimUserExtendedService,
	) {}

	getIconPath() {
		if (this.size === "big" && this.tile?.iconBig) {
			return this.icon_path + this.tile?.iconBig + ".svg";
		} else {
			return this.icon_path + this.tile?.icon + ".svg";
		}
	}
}
